import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactNode } from 'react';
import API from '../lib/api';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Use the shared Axios instance so baseURL, credentials, and XSRF config are respected
      queryFn: async ({ queryKey, signal }) => {
        const [url, config] = Array.isArray(queryKey) ? (queryKey as unknown as [string, Record<string, unknown>?]) : [String(queryKey) as unknown as string, undefined];
        const response = await API.request({
          url: String(url),
          method: 'get',
          signal,
          ...(config as Record<string, unknown> | undefined),
        });
        return response.data;
      },
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

interface QueryClientProviderProps {
  children: ReactNode;
}

export function QueryClientProviderWrapper({ children }: QueryClientProviderProps) {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
    </QueryClientProvider>
  );
}
